import { Collapse, Divider } from "antd";
import {
	ActionButtonComponent,
	EditEmployeeTransactionsContainer,
	EditItemsContainer,
} from "./style";
import { DiscoveryItems } from "./constants";
import CollapseExpandIcon from "../../components/CollapseExpandIcon";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useDiscoveryContext } from "../../context/DiscoveryContext/DiscoveryContext";

const AddDiscovery = () => {
	const { addDiscovery, loadingAddDiscoveryData } = useDiscoveryContext();
	return (
		<EditEmployeeTransactionsContainer>
			<EditItemsContainer>
				<h3>Yeni İçerik Ekleme</h3>
				<Divider />
				<Collapse
					items={DiscoveryItems}
					expandIconPosition="end"
					bordered={false}
					expandIcon={CollapseExpandIcon}
					defaultActiveKey={["1", "2", "3"]}
				/>
				<ActionButtonComponent>
					<MainButtonComponent onClick={addDiscovery} loading={loadingAddDiscoveryData}>
						İçerik Ekle
					</MainButtonComponent>
				</ActionButtonComponent>
			</EditItemsContainer>
		</EditEmployeeTransactionsContainer>
	);
};

export default AddDiscovery;
